import { useNavigate, useSearchParams } from "react-router-dom";

import { DrawerContextProvider } from "shared/contexts/DrawerContext";
import { DropdownMultiSelectContextProvider } from "shared/contexts/DropdownMultiSelectContext";
import Modal from "shared/components/feedback/modals/MasterModal";
import PageWrapper from "app/components/PageWrapper";
import RetainersForm from "features/admin/retainers/RetainersForm";
import RetainersTable from "features/admin/retainers/RetainersTable";
import { ServerSidePaginationContextProvider } from "shared/contexts/ServerSidePaginationContext";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal
                title="Add Retainer"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <RetainersForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal
                title="Edit Retainer"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <RetainersForm
                    retainerIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const Retainers = () => {
    return (
        <PageWrapper
            title="Retainers"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <ServerSidePaginationContextProvider>
                <DropdownMultiSelectContextProvider>
                    <DrawerContextProvider>
                        <FormPresenter />
                        <RetainersTable />
                    </DrawerContextProvider>
                </DropdownMultiSelectContextProvider>
            </ServerSidePaginationContextProvider>
        </PageWrapper>
    );
};

export default Retainers;
